// src/components/store/sections/faqs/FaqV28CardgridSunsetAmber.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV28CardgridSunsetAmber(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={28}
      archKey="card_grid"
      archLabel="Support Help Cards"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
